import { Component, OnInit } from '@angular/core';
import {WidgetBaseComponent} from '../widget-base/widget-base.component';
import {DoraProperty} from '../../Decorators/Decorator';
import {MessageChartPrint} from '../../messages/message-chart-print';

@Component({
  selector: 'dora-chart-print',
  templateUrl: './dora-chart-print.component.html',
  styleUrls: ['./dora-chart-print.component.scss']
})
export class DoraChartPrintComponent extends WidgetBaseComponent {

  @DoraProperty
  textId = 'PNG';
  text: string;

  @DoraProperty
  outputType = 'image/png';


  onParameterInjectedFinished(): void {
    super.onParameterInjectedFinished();

    this.translate.get(this.textId).subscribe((res: string) => {
      this.text = res;
    });
  }

  public onClick(): void {
    this.messageService.sendMessage(this.EventChannel, new MessageChartPrint(this.outputType), this.CallerName);
  }
}
